import type { ReactNode } from 'react';
import { Button, DatePicker, Input, Select, Space } from 'antd';
import {
  ExportOutlined,
  FilterOutlined,
  SearchOutlined,
  ShareAltOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import type { ConversationMode } from '@/services/aiAgent.service';

const MODE_OPTIONS = [
  { value: 'assistant', label: 'Assistant' },
  { value: 'analyst', label: 'Analyst' },
  { value: 'executive', label: 'Executive' },
];

export interface AIWorkspaceHeaderProps {
  title?: string;
  mode: ConversationMode;
  onModeChange: (mode: ConversationMode) => void;
  onTitleChange?: (title: string) => void;
  onOpenContext: () => void;
  onOpenSearch: () => void;
  onShare?: () => void;
  onExport?: () => void;
  pinCount?: number;
  onOpenDashboard?: () => void;
  mobileMenu?: ReactNode;
}

export function AIWorkspaceHeader({
  title,
  mode,
  onModeChange,
  onTitleChange,
  onOpenContext,
  onOpenSearch,
  onShare,
  onExport,
  pinCount,
  onOpenDashboard,
  mobileMenu,
}: AIWorkspaceHeaderProps) {
  return (
    <div
      style={{
        padding: '10px 20px',
        borderBottom: '1px solid var(--ai-border, rgba(0,0,0,0.06))',
        background: 'var(--ai-surface, #fff)',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flexWrap: 'wrap',
      }}
    >
      {mobileMenu}
      <Select size="small" value={mode} options={MODE_OPTIONS} onChange={onModeChange} style={{ width: 130 }} aria-label="Workspace mode" />
      <Input
        variant="borderless"
        value={title || 'New conversation'}
        onChange={(e) => onTitleChange?.(e.target.value)}
        onBlur={(e) => onTitleChange?.(e.target.value.trim())}
        style={{ flex: 1, minWidth: 160, fontWeight: 600, fontSize: 15 }}
        aria-label="Conversation title"
      />
      <Space wrap size={4}>
        <Button size="small" icon={<SearchOutlined />} onClick={onOpenSearch}>
          Search
        </Button>
        {onOpenDashboard ? (
          <Button size="small" onClick={onOpenDashboard}>
            Dashboard{pinCount ? ` (${pinCount})` : ''}
          </Button>
        ) : null}
        <DatePicker.RangePicker size="small" />
        {onShare ? <Button size="small" icon={<ShareAltOutlined />} onClick={onShare} aria-label="Share" /> : null}
        {onExport ? <Button size="small" icon={<ExportOutlined />} onClick={onExport} aria-label="Export" /> : null}
        <Button size="small" icon={<FilterOutlined />} onClick={onOpenContext} aria-label="Open context" />
        <Button size="small" icon={<SettingOutlined />} onClick={onOpenContext} aria-label="Settings" />
      </Space>
    </div>
  );
}
